import { Card, Container, Row, Col, Form } from "@deere/ux.uxframe-react";
import React, { Fragment } from 'react';
import { NEW_REQUEST5 } from '../../shared/Constants';
import { useLocation, Link } from 'react-router-dom';

export default function NewRequest5() {
    const location = useLocation();
    return (
        <Fragment>
            <title>PDC Parts Request Submitted (step 5)</title>
            <Card style={{ margin: '2%' }}>
                <Card.Body>
                    <Container fluid="xl">
                        <Row>
                            <Col xs={24}>
                                <Form.Group as={Row} className="mb-3" >
                                    <Form.Label style={{ marginLeft: '1.5%' }}><Link to='/'>Home</Link>&nbsp;&nbsp;/&nbsp;&nbsp;<Link to='/step1'>Step1</Link>&nbsp;&nbsp;/&nbsp;&nbsp;Step2&nbsp;&nbsp;/&nbsp;&nbsp;Step3&nbsp;&nbsp;/&nbsp;&nbsp;Step4&nbsp;&nbsp;/&nbsp;&nbsp;Step5</Form.Label>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={24}>
                                <Form.Group as={Row} className="mb-3" >
                                    <Form.Label className='firstline' style={{ marginLeft: '1.5%' }}>
                                        {NEW_REQUEST5}
                                    </Form.Label>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Container>
                    <Container fluid="xl">
                        <Row>
                            <Col xs={24}>
                                <Form.Group>
                                    <Form.Label>Your {location.state.comments === "test only" && <>Test</>} request for <font color="#990000">{location.state.material}</font> has been sent.</Form.Label><br />
                                    <Form.Label>It may take up to 3 minutes to be delivered.</Form.Label><br /><br />
                                    <Link to="/step1">Click here to start a new order</Link><br />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Container>
                </Card.Body>
            </Card>
        </Fragment>
    )

}
